export const DEFAULT_CURRENCY = 'USD';

const currenciesInfo = {
  AUD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 350,
      default: 6.49,
    },
    rent: {
      min: 0.01,
      max: 350,
      default: 3.79,
    },
    sale: {
      min: 0.01,
      max: 350,
      default: 3.79,
    },
  },
  BRL: {
    symbol: 'R$',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 810,
      default: 16.79,
    },
    rent: {
      min: 0.05,
      max: 810,
      default: 9.79,
    },
    sale: {
      min: 0.05,
      max: 810,
      default: 9.79,
    },
  },
  CAD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 350,
      default: 5.79,
    },
    rent: {
      min: 0.01,
      max: 350,
      default: 3.49,
    },
    sale: {
      min: 0.01,
      max: 350,
      default: 3.49,
    },
  },
  CHF: {
    symbol: 'CHF',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 247,
      default: 4.99,
    },
    rent: {
      min: 0.05,
      max: 247,
      default: 2.99,
    },
    sale: {
      min: 0.05,
      max: 247,
      default: 2.99,
    },
  },
  CZK: {
    symbol: 'Kč',
    offset: 2,
    subscription: {
      min: 1,
      max: 6740,
      default: 121.49,
    },
    rent: {
      min: 1,
      max: 6740,
      default: 72.49,
    },
    sale: {
      min: 1,
      max: 6740,
      default: 72.49,
    },
  },
  DKK: {
    symbol: 'kr',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 1670,
      default: 33.99,
    },
    rent: {
      min: 0.05,
      max: 1670,
      default: 19.99,
    },
    sale: {
      min: 0.05,
      max: 1670,
      default: 19.99,
    },
  },
  EUR: {
    symbol: '\u20ac',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 250,
      default: 4.99,
    },
    rent: {
      min: 0.01,
      max: 250,
      default: 2.99,
    },
    sale: {
      min: 0.01,
      max: 250,
      default: 2.99,
    },
  },
  GBP: {
    symbol: '\u00a3',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 150,
      default: 3.99,
    },
    rent: {
      min: 0.01,
      max: 150,
      default: 2.29,
    },
    sale: {
      min: 0.01,
      max: 150,
      default: 2.29,
    },
  },
  HKD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.1,
      max: 1940,
      default: 39,
    },
    rent: {
      min: 0.1,
      max: 1940,
      default: 24,
    },
    sale: {
      min: 0.1,
      max: 1940,
      default: 24,
    },
  },
  HUF: {
    symbol: 'Ft',
    offset: 2,
    subscription: {
      min: 5,
      max: 70000,
      default: 1389.49,
    },
    rent: {
      min: 5,
      max: 70000,
      default: 833.49,
    },
    sale: {
      min: 5,
      max: 70000,
      default: 833.49,
    },
  },
  ILS: {
    symbol: '\u20aa',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 1000,
      default: 17.9,
    },
    rent: {
      min: 0.01,
      max: 1000,
      default: 10.9,
    },
    sale: {
      min: 0.01,
      max: 1000,
      default: 10.9,
    },
  },
  JPY: {
    symbol: '\u00a5',
    offset: 0,
    subscription: {
      min: 1,
      max: 30000,
      default: 420,
    },
    rent: {
      min: 1,
      max: 30000,
      default: 360,
    },
    sale: {
      min: 1,
      max: 30000,
      default: 360,
    },
  },
  MXN: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.5,
      max: 4724,
      default: 94.49,
    },
    rent: {
      min: 0.5,
      max: 4724,
      default: 56.49,
    },
    sale: {
      min: 0.5,
      max: 4724,
      default: 56.49,
    },
  },
  MYR: {
    symbol: 'RM',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 1025,
      default: 20.49,
    },
    rent: {
      min: 0.05,
      max: 1025,
      default: 12.49,
    },
    sale: {
      min: 0.05,
      max: 1025,
      default: 12.49,
    },
  },
  NOK: {
    symbol: 'kr',
    offset: 2,
    subscription: {
      min: 1,
      max: 2090,
      default: 41.99,
    },
    rent: {
      min: 1,
      max: 2090,
      default: 24.99,
    },
    sale: {
      min: 1,
      max: 2090,
      default: 24.99,
    },
  },
  NZD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 380,
      default: 6.49,
    },
    rent: {
      min: 0.01,
      max: 380,
      default: 3.79,
    },
    sale: {
      min: 0.01,
      max: 380,
      default: 3.79,
    },
  },
  PHP: {
    symbol: '₱',
    offset: 2,
    subscription: {
      min: 1,
      max: 11690,
      default: 233.99,
    },
    rent: {
      min: 1,
      max: 11690,
      default: 139.99,
    },
    sale: {
      min: 1,
      max: 11690,
      default: 139.99,
    },
  },
  PLN: {
    symbol: 'zł',
    offset: 2,
    subscription: {
      min: 1,
      max: 980,
      default: 19.79,
    },
    rent: {
      min: 1,
      max: 980,
      default: 11.79,
    },
    sale: {
      min: 1,
      max: 980,
      default: 11.79,
    },
  },
  RUB: {
    symbol: '\u20bd',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 15000,
      default: 279,
    },
    rent: {
      min: 0.01,
      max: 15000,
      default: 169,
    },
    sale: {
      min: 0.01,
      max: 15000,
      default: 169,
    },
  },
  SEK: {
    symbol: 'kr',
    offset: 2,
    subscription: {
      min: 1,
      max: 2148,
      default: 42.79,
    },
    rent: {
      min: 1,
      max: 2148,
      default: 25.79,
    },
    sale: {
      min: 1,
      max: 2148,
      default: 25.79,
    },
  },
  SGD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 340,
      default: 6.79,
    },
    rent: {
      min: 0.05,
      max: 340,
      default: 4.79,
    },
    sale: {
      min: 0.05,
      max: 340,
      default: 4.79,
    },
  },
  THB: {
    symbol: '฿',
    offset: 2,
    subscription: {
      min: 0.5,
      max: 8660,
      default: 172.79,
    },
    rent: {
      min: 0.5,
      max: 8660,
      default: 103.49,
    },
    sale: {
      min: 0.5,
      max: 8660,
      default: 103.49,
    },
  },
  TWD: {
    symbol: 'NT$',
    offset: 2,
    subscription: {
      min: 1,
      max: 7936,
      default: 158.49,
    },
    rent: {
      min: 1,
      max: 7936,
      default: 94.99,
    },
    sale: {
      min: 1,
      max: 7936,
      default: 94.99,
    },
  },
  USD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 250,
      default: 4.99,
    },
    rent: {
      min: 0.01,
      max: 250,
      default: 2.99,
    },
    sale: {
      min: 0.01,
      max: 250,
      default: 2.99,
    },
  },
};

export default currenciesInfo;

export const defaultCurrencyInfo = currenciesInfo[DEFAULT_CURRENCY];



// WEBPACK FOOTER //
// ./src/shared/constants/currencies.js